import { YoutubePlatform } from '@app/modules/social-export/domain/platforms';
import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { DefaultPlatformConnect } from '../../../screens/manage/DefaultPlatformConnect';
import { youtubeConnectMessages as messages } from './youtube-connect-messages';

type Props = {
  stationId: string;
};

/** YouTube OAuth connect options: basic (upload only) and advanced (delete + playlists). */
export function YoutubeConnect({ stationId }: Props) {
  const { $t } = useIntl();

  return (
    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" alignItems="flex-start">
      <Box>
        <DefaultPlatformConnect platform={YoutubePlatform} stationId={stationId}>
          {$t(messages.connectBasic)}
        </DefaultPlatformConnect>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          <FormattedMessage {...messages.connectBasicDescription} />
        </Typography>
      </Box>
      <Box>
        <DefaultPlatformConnect
          platform={YoutubePlatform}
          stationId={stationId}
          loginSuffix="advanced"
        >
          {$t(messages.connectAdvanced)}
        </DefaultPlatformConnect>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          <FormattedMessage {...messages.connectAdvancedDescription} />
        </Typography>
      </Box>
    </Stack>
  );
}
